import { render, staticRenderFns } from "./StockMove.vue?vue&type=template&id=57b68302&"
import script from "./StockMove.vue?vue&type=script&lang=js&"
export * from "./StockMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports